<template>
    <div class="dashboard__view">
        <div class="page">
            <div class="page__title">Direct Debit Mandate</div>
        </div>

        <div @click="$router.go(-1)" class="page__nav">
            <div class="page__nav__icon">
                <svg fill="none" height="16" viewBox="0 0 19 16" width="19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z" fill="#655D79" />
                </svg>
            </div>
            <div class="page__nav__text">Mandate Details</div>
        </div>

        <div class="details">
            <div class="details__card">
                <div class="details__card__container">
                    <div class="details__card__item">
                        <div class="details__card__item__left">Details</div>
                        <div class="details__card__item__right">
                            <button :disabled="cancellingMandate" @click="cancelMandate" class="btn btn--sm btn--flex btn--default" v-if="showCancelButton">
                                <div class="btn--text" v-if="cancellingMandate">Cancelling...</div>
                                <div class="btn--text" v-else>Cancel Mandate</div>
                            </button>
                        </div>
                    </div>

                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Mandate Reference</div>
                            <div class="details__card__item__value">{{mandate.mandate_reference}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Bank</div>
                            <div class="details__card__item__value uppercase">{{bankNames[mandate.bank_code] ? bankNames[mandate.bank_code].name : mandate.bank_code}}</div>
                        </div>
                    </div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Account Name</div>
                            <div class="details__card__item__value">{{mandate.customer_name}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Account Email</div>
                            <div class="details__card__item__value">{{mandate.customer_email || "N/A"}}</div>
                        </div>
                    </div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Account Number</div>
                            <div class="details__card__item__value">{{mandate.account_number}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Amount</div>
                            <div class="details__card__item__value">{{mandate.currency}}{{mandate.amount | money}}</div>
                        </div>
                    </div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Frequency</div>
                            <div class="details__card__item__value">{{mandate.frequency}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Initiation Date</div>
                            <div class="details__card__item__value">{{mandate.createdAt | date }}</div>
                        </div>
                    </div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Authorization Date</div>
                            <div class="details__card__item__value">{{mandate.updatedAt | date }}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Start Date</div>
                            <div class="details__card__item__value">{{ mandate.start_date | date }}</div>
                        </div>
                    </div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">End Date</div>
                            <div class="details__card__item__value">{{mandate.end_date | date}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Validation Method</div>
                            <div class="details__card__item__value">{{mandate.auth_type}}</div>
                        </div>
                    </div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Status</div>
                            <div class="details__card__item__value">
                                <span class="tag active" v-if="String(mandate.status).toLowerCase().trim() == 'active'">Active</span>
                                <span class="tag pending" v-else-if="String(mandate.status).match(/(pending)/ig)">Pending</span>
                                <span class="tag inactive" v-else>{{mandate.status}}</span>
                            </div>
                        </div>
                        <!-- <div class="details__card__item__right">
                            <div class="details__card__item__label">Validation Method</div>
                            <div class="details__card__item__value">{{mandate.auth_type}}</div>
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- <div class="details__trail">
                <div class="details__trail__header">Audit Trail</div>
                <div :key="item.timestamp" class="details__trail__item" v-for="item in audit">
                    <div class="details__trail__item__action">{{item.entity_actor}} {{item.entity_comment}}</div>
                    <div class="details__trail__item__time">{{item.timestamp | date}}</div>
                </div>
            </div> -->
            <div class="details__trail">
                <div class="details__card__container">
                    <div class="details__card__header">Customer Details</div>

                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Customer Reference</div>
                            <div class="details__card__item__value">{{mandate.customer_reference}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Customer Name</div>
                            <div class="details__card__item__value">{{mandate.customer_name}}</div>
                        </div>
                    </div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Customer Phone</div>
                            <div class="details__card__item__value">{{mandate.customer_phone || "N/A"}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Customer Email</div>
                            <div class="details__card__item__value">{{mandate.customer_email || "N/A"}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mandate: "",
            audit: "",
            cancellingMandate: false,
            showCancelButton: false,
        };
    },

    created() {
        this.fetchTransaction();
    },

    computed: {
        bankNames() {
            return this.$store.state.bankNames;
        }
    },

    methods: {
        fetchTransaction() {
            this.$http.get(`${process.env.VUE_APP_DD_API_URL}/admin/mandates/${this.$route.params.id}`)
            .then(response => {
                // console.log("MANDATE DETAILS>>>", response);
                const { body } = response.body;
                if (Object.keys(body).length > 0) {
                    this.mandate = body;
                    // this.fetchAudit(response.body.data.transactions[0].unique_reference);
                    if (String(this.mandate.status).toLowerCase().trim() != 'cancelled' && String(this.mandate.frequency).toLowerCase().trim() != 'instant') this.showCancelButton = true;
                }
            });
        },
        /* fetchAudit(value) {
            this.$http.get(`dashboard/audits?entity_id=${value}&entity_type=transaction`).then(response => {
                this.audit = response.body.data.audits;
            });
        } */
        formatDate(date) {
            return moment(date).format("LLL");
        },
        cancelMandate() {
            // console.log("cancel mandate here...");
            this.cancellingMandate = true;
            this.$http.put(`${process.env.VUE_APP_DD_API_URL}/admin/mandates/cancel/${this.$route.params.id}`)
            .then(response => {
                const { statusCode, message } = response.body;
                // console.log("MANDATE CANCEL>>>", response);
                if (statusCode == 200) {
                    let queryObject = {};
                    queryObject.page = 1;
                    this.$notify({
                        group: "notifications-default",
                        type: "success text-white",
                        title: "Success",
                        text: message,
                    });
                    
                    // Go back to previous page
                    this.$router.go(-1);
                } else {
                    this.$notify({
                        group: "notifications-default",
                        type: "error text-white",
                        title: "Error",
                        text: message,
                    });
                }
            })
            .catch(error => {
                this.$notify({
                    group: "notifications-default",
                    type: "error text-white",
                    title: "Error",
                    text: error.body.message,
                });
            })
            .finally(() => {
                this.cancellingMandate = false;
            });
        },
    }
};
</script>